<template>
    <div class="w-full h-full relative">
        <div class="flex items-end justify-between gap-2">
            <span v-if="isLoading"> Cargando...</span>
            <custom-multiple-select
                v-else
                v-model="options"
                mode="search"
                label="Roles"
                class="w-full"
                :options="selectOptions"
                :disabled="!enabled"
                @change="onInput"
            />
            <app-button
                v-if="enabled"
                icon
                circle
                color="brand-purple"
                @click="reloadItems(true)"
            >
                <reload-icon class="h-5 w-5 text-white" />
            </app-button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import CustomMultipleSelect from "@/components/utils/CustomMultipleSelect.vue";

export default {
    name: "RoleSelector",
    components: { ReloadIcon, CustomMultipleSelect },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        itemsCurrent: {
            type: Array,
            default: () => [],
            required: true
        },
        defaultFilters: {
            default: () => ({}),
            type: Object,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        options: [],
        optionsBase: [],
        isLoading: false
    }),
    computed: {
        ...mapGetters("control", ["backgroundColor"]),
        selectOptions() {
            return this.optionsBase.map((item) => ({
                label: item.name,
                value: item.slug
            }));
        }
    },
    watch: {
        itemsCurrent(value) {
            this.setInput(value);
        }
    },
    async mounted() {
        this.setInput(this.itemsCurrent);
        this.reloadItems(true);
    },
    methods: {
        ...mapActions("roles", ["listAssignableRoles"]),
        async reloadItems(required = true) {
            this.isLoading = true;
            try {
                const optionsBase = await this.listAssignableRoles({
                    required,
                    ...this.defaultFilters
                });
                this.optionsBase = [...optionsBase];
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        onInput(value) {
            const complete = this.optionsBase.filter((item) =>
                value.includes(item.slug)
            );
            this.$emit("change", complete);
        },
        setInput(values) {
            const aux = values.every((item) =>
                this.optionsBase.some((item2) => item2.slug === item.slug)
            );
            if (!aux) {
                this.optionsBase = [...this.optionsBase, ...values].filter(
                    (value, index, self) =>
                        self.findIndex((item) => item.slug === value.slug) ===
                        index
                );
            }
            this.options = values.map((item) => item.slug);
            this.isLoading = false;
        }
    }
};
</script>
